import * as React from 'react';
import { Icon } from 'components/icon/icon';
import TagIcon from 'public/assets/icons/tag.svg';

import styles from './tags.module.scss';
import { Tag } from 'api/graphql-types';

export interface ITagsProps {
	tags: Tag[];
}

const Tags = (props: ITagsProps): React.JSX.Element => {
	if (props.tags?.length < 1) {
		return (
			<div className={styles.tags}>
				<span className={styles.tag} />
			</div>
		);
	}

	return (
		<div className={styles.tags}>
			<Icon customIcon={<TagIcon />} size="24px" />
			{props.tags?.map((tag: Tag, i: number) => {
				return (
					<span key={tag?.documentId} className={styles.tag}>
						{` ${tag?.name}${i + 1 < props.tags?.length ? ', ' : ''} `}
					</span>
				);
			})}
		</div>
	);
};

export default Tags;
